import { AlertModalComponent } from './../alert/alert.component';
import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SaveEINOrgDetail, LoadEinConfigurationStateFail } from '../../../screens/ein-configuration/state/ein-configuration.actions';
import { Store } from '@ngrx/store';
import * as fromEinConfiguration from '../../../screens/ein-configuration/state/ein-configuration.selectors';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LGEDataService } from 'src/commons';
import { ConfirmModalComponent } from '..';


@Component({
    selector: 'ein-org-modal',
    templateUrl: './ein-org-details.component.html',
    styleUrls: ['./ein-org-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EinOrgDetailsComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() message: string;
    @Input() einOrgInfo: any;
    @Input() einOrgDetail: any;

    einOrgForm: FormGroup;
    einOrgGuideStar: FormGroup;
    isVerifyGS = false;
    isLoading = true;
    showError = false;
    errorMessage = "";
    isEditMode: boolean;
    isReadOnly = false;
    public confirm: any;
    alert: any

    states = ['AK', 'AL', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY',
        'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK',
        'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];
    taxExcemptList = [];

    constructor(
        private store: Store<fromEinConfiguration.State>,
        private _dataService: LGEDataService,
        private dialog: MatDialog,
        private ref: ChangeDetectorRef,
        private dialogRef: MatDialogRef<EinOrgDetailsComponent>,
        private fb: FormBuilder, @Inject(MAT_DIALOG_DATA) private data: any) {
        this.message = data.message;
        this.title = data.title;
        this.einOrgInfo = data.einOrgInfo;
        this.einOrgDetail = data.einOrgDetail;
        this.isEditMode = data.isEditMode;
    }

    ngOnInit() {
        this.createForms();
        this._dataService.GetTaxExemptSubsections().subscribe(data => {
            this.taxExcemptList = data.map(s => s.subsection);
        });
        this.isVerifyGS = !this.einOrgInfo.isValid && this.einOrgInfo.isException;
        this.einOrgGuideStar.reset();
        if (this.isVerifyGS) {
            this.showError = false;
            this.errorMessage = "";
            this._dataService.CharityCheckGuideStar(this.einOrgInfo.ein).subscribe({
                next: (result) => {
                    this.isLoading = false;
                    let einOrgGuideStar: any = {};
                    einOrgGuideStar.ein = result.ein;
                    einOrgGuideStar.organization_name = result.organization_name;
                    einOrgGuideStar.address_line1 = result.address_line1;
                    einOrgGuideStar.address_line2 = result.address_line2;
                    einOrgGuideStar.city = result.city;
                    einOrgGuideStar.state = result.state;
                    einOrgGuideStar.zip = result.zip;
                    einOrgGuideStar.isException = result.isException;
                    einOrgGuideStar.isValid = result.isValid;
                    einOrgGuideStar.lastUpdated = new Date();
                    einOrgGuideStar.einOrgInfoId = result.einOrgInfoId;
                    einOrgGuideStar.subsection_501 = result.subsection_501
                    einOrgGuideStar.deleteIt = false;
                    this.einOrgGuideStar.setValue(einOrgGuideStar);
                    this.ref.markForCheck();
                },
                error: error => {
                    this.isLoading= false;
                    this.showError = true;
                    this.errorMessage = error.includes("(404) Not Found") ? "GuideStar API returns no information for the entered tax id/EIN" : error.message;
                    this.ref.markForCheck();
                }
            })
        }
    }

    createForms(): void {
        this.einOrgForm = this.fb.group({
            'ein': ['', [Validators.required, Validators.maxLength(10), Validators.pattern(new RegExp(/^\d{2}-\d{7}/))]],
            'organization_name': ['', [Validators.required, Validators.maxLength(80)]],
            'address_line1': ['', [Validators.required, Validators.maxLength(35)]],
            'address_line2': ['', [Validators.maxLength(35)]],
            'city': ['', [Validators.required, Validators.maxLength(25)]],
            'state': ['', [Validators.required, Validators.maxLength(10)]],
            'zip': ['', [Validators.required, Validators.maxLength(9), Validators.pattern(new RegExp(/^\d{5}$|^\d{9}$/))]],
            'isException': [null],
            'isValid': [null],
            'lastUpdated': [''],
            'einOrgInfoId': [null],
            'subsection_501': [''],
            'deleteIt': [false],
        });
        this.einOrgGuideStar = this.fb.group({
            'ein': ['', [Validators.required, Validators.maxLength(10), Validators.pattern(new RegExp(/^\d{2}-\d{7}/))]],
            'organization_name': ['', [Validators.required, Validators.maxLength(50)]],
            'address_line1': ['', [Validators.required, Validators.maxLength(35)]],
            'address_line2': ['', [Validators.maxLength(35)]],
            'city': ['', [Validators.required, Validators.maxLength(50)]],
            'state': ['', [Validators.required, Validators.maxLength(10)]],
            'zip': ['', [Validators.required, Validators.maxLength(9), Validators.pattern(new RegExp(/^\d{5}$|^\d{9}$/))]],
            'isException': [0],
            'isValid': [null],
            'lastUpdated': [''],
            'einOrgInfoId': [null],
            'subsection_501': [''],
            'deleteIt': [false],
        });
        this.einOrgForm.setValue(this.einOrgInfo);
        this.ref.markForCheck();
    }

    getTaxExemptStatus(value) {
        if (value === '')
            return 'Other';
        else if (isNaN(value) || +value === 0) {
            return value;
        } else {
            return `501(c)(${+value})`;
        }
    }

    public showConfirm(title: string, message: string) {
        this.confirm = this.dialog.open(ConfirmModalComponent, {
            width: '350px',
            disableClose: false,
            data: { title: title, message: message }
        });
    }

    public showAlert(title: string, message: string) {
        this.alert = this.dialog.open(AlertModalComponent, {
            width: '260px',
            disableClose: true,
            data: { title: title, message: message }
        });
    }

    onSave() {
        const isDuplicate = this.einOrgDetail.filter(e => e.ein === this.einOrgForm.value.ein).length > 0;
        if (isDuplicate) {
            this.showAlert('Alert!', 'EIN:  "' + this.einOrgForm.value.ein + '"  is already exist!');
        } else {
            this.showConfirm('Are you sure you want to save?', '');
            this.confirm.afterClosed().subscribe(result => {
                if (result === 'yes') {
                    let orgName = (this.einOrgForm.value.organization_name).toUpperCase();
                    this.einOrgForm.value.organization_name = orgName;
                    this.store.dispatch(new SaveEINOrgDetail(this.einOrgForm.value));
                    this.dialogRef.close();
                }
            });
        }
    }

    onUpdate(isGS: boolean) {
        this.showConfirm('Are you sure you want to update?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                if (isGS) {
                    let orgName = (this.einOrgGuideStar.value.organization_name).toUpperCase();
                    this.einOrgGuideStar.value.organization_name = orgName;
                    this.store.dispatch(new SaveEINOrgDetail(this.einOrgGuideStar.value));

                } else {
                    let orgName = (this.einOrgForm.value.organization_name).toUpperCase();
                    this.einOrgForm.value.organization_name = orgName;
                    this.store.dispatch(new SaveEINOrgDetail(this.einOrgForm.value));
                }
                this.dialogRef.close();
            }
        });
    }

    onCancel() {
        this.showConfirm('Are you sure you want to cancel?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                this.dialogRef.close();
            }
        });
    }


    onDelete() {
        this.showConfirm('Are you sure you want to delete?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                this.einOrgForm.value.deleteIt = true;
                this.store.dispatch(new SaveEINOrgDetail(this.einOrgForm.value));
                this.dialogRef.close();
            }
        });
    }

    ngOnDestroy() {

    }
}
